var _defs, _use;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "15px",
    viewBox: "0 0 15 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M13.11.75c-1-1-2.75-1-3.76 0L1.6 8.51a.68.68 0 00-.15.26l-.02.01-1.38 4.17a.7.7 0 00.87.88l4.17-1.39h.02c.1-.04.18-.1.25-.17l7.76-7.76a2.64 2.64 0 000-3.76zm-.98 2.78l-.32.32-1.8-1.8.32-.31a1.3 1.3 0 011.8 0 1.26 1.26 0 010 1.8zM2.39 10.3l1.19 1.19-1.79.6.6-1.8zm2.47.51L3.06 9l5.97-5.96 1.8 1.8-5.97 5.96z",
    id: "a"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    fill: "#50B83C",
    xlinkHref: "#a",
    transform: "translate(.8 .8)",
    fillRule: "evenodd"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.ee4a0211.svg";
export { ForwardRef as ReactComponent };